import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Typography, Button, Grid, Rating, Divider } from "@mui/material";
import { productDataList } from "../data/productListData";

const ProductPage = () => {
  const { id } = useParams(); // Get product ID from URL params
  const [product, setProduct] = useState(null); // Store product data
  useEffect(() => {
    // Simulate an API call to fetch the product data by ID
    const fetchProduct = () => {
      const productData = productDataList.find(
        (product) => product.id === parseInt(id)
      );
      setProduct(productData);
    };

    fetchProduct();
  }, [id]);

  if (!product) return <Typography>Loading...</Typography>;

  return (
    <Box sx={{ padding: 3, maxWidth: 1200, margin: "auto" }}>
      <Grid container spacing={3}>
        {/* Product Images Section */}
        <Grid item xs={12} sm={6}>
          <Box>
            <img
              src={product.imageUrls[0]}
              alt={product.name}
              style={{
                width: "50%",
                height: "auto",
                marginBottom: 16,
                borderRadius: 8,
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
              }}
            />
            {/* Add a simple carousel or gallery if you like */}
            <Box sx={{ display: "flex", gap: 2 }}>
              {product.imageUrls.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Product image ${index + 1}`}
                  style={{
                    width: 80,
                    height: 80,
                    borderRadius: 8,
                    cursor: "pointer",
                    border: "1px solid #ddd",
                    boxSizing: "border-box",
                  }}
                />
              ))}
            </Box>
          </Box>
        </Grid>

        {/* Product Information Section */}
        <Grid item xs={12} sm={6}>
          <Typography variant="h4" sx={{ fontWeight: "bold", marginBottom: 2 }}>
            {product.name}
          </Typography>

          {/* Rating */}
          <Box sx={{ marginBottom: 2 }}>
            <Rating
              name="product-rating"
              value={product.rating}
              readOnly
              precision={0.5}
              size="large"
            />
            <Typography variant="body2" color="textSecondary">
              {product.reviews.length} reviews
            </Typography>
          </Box>

          {/* Price and Discount */}
          <Box sx={{ marginBottom: 2 }}>
            <Typography variant="h5" color="primary" sx={{ marginBottom: 1 }}>
              ${product.price}
            </Typography>
            {product.originalPrice && (
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{
                  textDecoration: "line-through",
                  marginBottom: 1,
                  display: "inline-block",
                  marginRight: 1,
                }}
              >
                ${product.originalPrice}
              </Typography>
            )}
            <Typography variant="body2" color="success.main">
              Save ${product.originalPrice - product.price}
            </Typography>
          </Box>

          {/* Product Description */}
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{ marginBottom: 2 }}
          >
            {product.description}
          </Typography>

          {/* Action Buttons */}
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button variant="contained" color="primary" sx={{ flexGrow: 1 }}>
              Add to Cart
            </Button>
            <Button variant="outlined" color="primary">
              Buy Now
            </Button>
          </Box>

          <Divider sx={{ marginY: 2 }} />

          {/* Reviews Section */}
          <Typography variant="h6" sx={{ marginBottom: 1 }}>
            Customer Reviews
          </Typography>
          {product.reviews.map((review, index) => (
            <Box key={index} sx={{ marginBottom: 1 }}>
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                {review.user}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {review.comment}
              </Typography>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProductPage;
